import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Modal,
  ModalHeader
} from "reactstrap"
import i18n from "../../../i18n"

import Step1 from "./Step1";
import Step2 from "./Step2";

const GroupOriginRoutingModal = (props) => {

  const { isOpen, toggle, setShowModalOrigin, setGroupOriginRoutingModal, listModifyRouting, setSelectedRoutingOrigin } = props;

  const [step, setStep] = useState(1);
  const [selectRouting, setSelectRouting] = useState(null);

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="GroupOriginRoutingModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size="xl"
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>{i18n.t("GroupOrigin")}</ModalHeader>
        {(() => {
            switch(step) {
              case 1:
                return <Step1
                         listModifyRouting={listModifyRouting}
                         setSelectRouting={setSelectRouting}
                         setGroupOriginRoutingModal={setGroupOriginRoutingModal}
                         setStep={setStep}></Step1>
              case 2:
                return <Step2
                         setShowModalOrigin={setShowModalOrigin}
                         setSelectRouting={setSelectRouting}
                         setSelectedRoutingOrigin={setSelectedRoutingOrigin}
                         setGroupOriginRoutingModal={setGroupOriginRoutingModal}
                         selectRouting={selectRouting}
                         toggle={toggle}
                         setStep={setStep}></Step2>
            }
        })()}
      </div>
    </Modal>
  )
}

GroupOriginRoutingModal.propTypes = {
  GroupOriginRoutingModal: PropTypes.func,
  setShowModalOrigin: PropTypes.func,
  toggle: PropTypes.func,
  setSelectedRoutingOrigin: PropTypes.func,
  isOpen: PropTypes.bool
}

export default GroupOriginRoutingModal;

